export default __webpack_public_path__ + "static/people-profile-118fee7080a0d30777ae6643f3c21da8.png";